// extracted by mini-css-extract-plugin
module.exports = {"headerImage":"_2dbysM4i_Dz3oBuRt08sBd","themeworldDescription":"_2dx5_Uw41EbNODK9BFS-dm"};